/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
Menu Button
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       13th December 2022

*******************************************************************************************/
import { 
    styled, 
    Button as ButtonMUI, 
}                                       from '@mui/material';
import { FONT_FAMILY_FEATURE }          from 'themes';

export const MenuButton = styled(ButtonMUI)( ({theme}) => ({
    fontFamily      : FONT_FAMILY_FEATURE,
    fontWeight      : 600,
    // textTransform   : 'lowercase',
    textTransform   : 'capitalize',
    fontSize        : '0.9rem',
    color           : theme.palette.text.primary,
    minWidth        : 0
}))

export default MenuButton;